export default {
  All: 'All',
  Any: 'Any'
}
